/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landskin_Title_1Inputs */

const en_landskin_title_1 = /** @type {(inputs: Landskin_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forest`)
};

const ar_landskin_title_1 = /** @type {(inputs: Landskin_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const de_landskin_title_1 = /** @type {(inputs: Landskin_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const es_landskin_title_1 = /** @type {(inputs: Landskin_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const fr_landskin_title_1 = /** @type {(inputs: Landskin_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const it_landskin_title_1 = /** @type {(inputs: Landskin_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const ja_landskin_title_1 = /** @type {(inputs: Landskin_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const ko_landskin_title_1 = /** @type {(inputs: Landskin_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const pt_br_landskin_title_1 = /** @type {(inputs: Landskin_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const ru_landskin_title_1 = /** @type {(inputs: Landskin_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const th_landskin_title_1 = /** @type {(inputs: Landskin_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const tr_landskin_title_1 = /** @type {(inputs: Landskin_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const zh_cn_landskin_title_1 = /** @type {(inputs: Landskin_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (``)
};

const zh_tw_landskin_title_1 = /** @type {(inputs: Landskin_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`森林`)
};

/**
* | output |
* | --- |
* | "Forest" |
*
* @param {Landskin_Title_1Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const landskin_title_1 = /** @type {((inputs?: Landskin_Title_1Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landskin_Title_1Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landskin_title_1(inputs)
	if (locale === "ar") return ar_landskin_title_1(inputs)
	if (locale === "de") return de_landskin_title_1(inputs)
	if (locale === "es") return es_landskin_title_1(inputs)
	if (locale === "fr") return fr_landskin_title_1(inputs)
	if (locale === "it") return it_landskin_title_1(inputs)
	if (locale === "ja") return ja_landskin_title_1(inputs)
	if (locale === "ko") return ko_landskin_title_1(inputs)
	if (locale === "pt_br") return pt_br_landskin_title_1(inputs)
	if (locale === "ru") return ru_landskin_title_1(inputs)
	if (locale === "th") return th_landskin_title_1(inputs)
	if (locale === "tr") return tr_landskin_title_1(inputs)
	if (locale === "zh_cn") return zh_cn_landskin_title_1(inputs)
	return zh_tw_landskin_title_1(inputs)
});